import React from "react";
import { usePermissions } from "../../context/PermissionContext";

/**
 * Renders `children` only when the user satisfies the permission check.
 *
 * Usage:
 *   <PermissionGate permission="business.add">
 *     <button>Add Business</button>
 *   </PermissionGate>
 *
 *   <PermissionGate anyOf={["business.add", "business.update"]}>
 *     ...
 *   </PermissionGate>
 *
 *   <PermissionGate allOf={["business.add", "business.upload"]}>
 *     ...
 *   </PermissionGate>
 */
const PermissionGate = ({
  permission,
  anyOf = [],
  allOf = [],
  fallback = null,
  children,
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } =
    usePermissions();

  let allowed = true;

  if (permission) {
    allowed = hasPermission(permission);
  } else if (allOf.length > 0) {
    allowed = hasAllPermissions(allOf);
  } else if (anyOf.length > 0) {
    allowed = hasAnyPermission(anyOf);
  }

  return allowed ? children : fallback;
};

export default PermissionGate;